import Component from '../core/Component'
import Scroll from '../services/Scroll'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import debounce from 'lodash/debounce'
import EventBus from '../core/EventBus'

const STATES = {
    DESKTOP_READY: 'is-desktop-ready'
}

export default class SectionCard extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            inner: null,
            overlay: null
        }

        this.state = null
        this.desktopEnquireHandler = {
            match: () => this.attachDesktop(),
            unmatch: () => this.detachDesktop(),
        }
        this.debouncedResize = debounce(() => this.resize(), 400)
    }

    prepare() {
        enquire.register(queries.largeUp, this.desktopEnquireHandler)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.desktopEnquireHandler)
    }

    attachDesktop() {
        this.debouncedResize()
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        EventBus.on('dom:change', this.handleDomChange)
        this.element.classList.add(STATES.DESKTOP_READY)
    }

    detachDesktop() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
        EventBus.off('dom:change', this.handleDomChange)
        this.element.classList.remove(STATES.DESKTOP_READY)
        this.clear()
    }

    handleDomChange = () => {
        this.debouncedResize()
    }

    handleResize = () => {
        this.debouncedResize()
    }

    handleScroll = () => {
        this.render()
    }

    resize() {
        if (!this.is(STATES.DESKTOP_READY)) {
            return
        }

        const scrollY = Scroll.getScroll().y
        const windowHeight = Scroll.window.height

        const rect = this.element.getBoundingClientRect()
        const distanceTotal = rect.height > windowHeight ? windowHeight : rect.height

        this.state = {
            distanceCurrent: this.state?.distanceCurrent ?? 0,
            distanceTotal,
            documentStartY: scrollY + rect.top - windowHeight
        }

        this.render()
    }

    render() {
        if (!this.state) {
            return
        }

        const scrollY = Scroll.getScroll().y
        const OVERBUFFER = 100
        if (scrollY > this.state.documentStartY - OVERBUFFER && scrollY < this.state.documentStartY + this.state.distanceTotal + OVERBUFFER) {
            const startDiff = Math.max(scrollY - this.state.documentStartY, 0)

            const distance = Math.min(startDiff - this.state.distanceTotal, 0)
            const progress = Math.abs(distance / this.state.distanceTotal)

            if (this.ref.overlay) {
                this.ref.overlay.style.opacity = progress
            }
            if (this.ref.inner) {
                this.ref.inner.style.transform = `translateY(${distance}px)`
                this.state.distanceCurrent = distance
            }
        }

        if (this.ref.overlay && scrollY > this.state.documentStartY + this.state.distanceTotal) {
            this.ref.overlay.style.opacity = 0
        }
    }

    clear() {
        this.state = null

        if (this.ref.inner) {
            this.ref.inner.style.transform = ''
        }
        if (this.ref.overlay) {
            this.ref.overlay.style.opacity = ''
        }
    }
}